import { defineMessages } from 'react-intl'

export default defineMessages({
  errorSuggestedRetailersLimit: {
    id: 'organization.errorSuggestedRetailersLimit',
    defaultMessage: 'Sorry, only maximum {limit} endpoints can be flagged per market.{details}',
  },
  errorSuggestedRetailersLimitWithoutDetails: {
    id: 'organization.errorSuggestedRetailersLimitWithoutDetails',
    defaultMessage: 'Sorry, only maximum {limit} endpoints can be flagged per market.',
  },
})
